<div *ngIf="events" class="grid-x" style="margin-bottom: 1rem;">

  <div class="cell shrink"
       style="display: flex; flex-direction: column; align-items: center">
    <span class="mois-event margin-b-xs">{{month}}</span>
    <span class="date-event">{{day}}
      <sup *ngIf="day === '1'">{{'news.event.ordinal.first' | translate}}</sup>
    </span>
  </div>

  <!--Basic events item-->
  <ng-container *ngIf="events.length > 0">
    <div class="cell auto">
      <div *ngFor="let event of events"
           class="bg-white border-event {{getClassByTheme(event)}}"
           style="border-radius: 5px 0 0 5px">

        <div class="paragraphe-event bg-transparent bg-hover">
          <div class="grid-x">

            <div class="cell auto">
              <div (click)="gotToProgram(event)"
                   class="cursor-hover padding-t-xs">
                <i *ngIf="event.focus"
                   class="fa fa-star margin-r-s"
                   style="font-size: 1.2rem; color: #ecc104"></i>
                <span class="i-block margin-b-xs f-7 font-bold c-black">{{event.title}}</span><br/>
                <div class="line-clamp">{{event.description}}</div>
              </div>
            </div>

            <div class="cell shrink">
              <ng-container *ngIf="isBackOffice">
                <div class="margin-b-s" style="display: flex; justify-content: flex-end;">
                  <span (click)="openEditEventDialog(event)"
                        class="fa fa-pencil margin-r-s"></span>
                  <span (click)="onOpenDeleteContact(event)"
                        class="fa fa-close margin-r-s"></span>
                </div>
              </ng-container>
              <div style="display: flex; flex-direction: column; justify-content: space-between; align-items: flex-end">
                <div class="margin-b-s">
                  <span class="hds-chip condensed small get chips {{getColorByTheme(event)}}"
                        style="font-weight:500; font-size:11px; width: fit-content;">
                    <ng-container *ngIf="event.theme; else theme">
                      {{'widget.latest-events.theme.'.concat(event.theme) | translate}}
                    </ng-container>
                    <ng-template #theme>
                      {{event.category}}
                    </ng-template>
                  </span>
                </div>
                <!--Event links-->
                <a *ngIf="hasLinkByType(event, linkTypeEnum.SUBSCRIPTION_LINK)"
                   [href]="getLinkByType(event, linkTypeEnum.SUBSCRIPTION_LINK)" (click)="onRedirectToEvent(event, true)"
                   class="hds-chip condensed light-gray border-radius-default small hollow-subscription"
                   style="width: fit-content">
                  <span class="hollow-subscription-text"
                        style="display: flex; align-items: center; font-weight: 500">
                    <i class="fal fa-calendar-check margin-r-xs"
                       style="font-size: 1.2rem"></i>
                    {{'news.event.subscribe-event' | translate}}
                  </span>
                </a>
                <a *ngIf="hasLinkByType(event, linkTypeEnum.COMMERCIAL_LINK) && !hasLinkByType(event, linkTypeEnum.SUBSCRIPTION_LINK)"
                   [href]="getLinkByType(event, linkTypeEnum.COMMERCIAL_LINK)" (click)="onRedirectToEvent(event, false)"
                   class=" hds-chip condensed light-gray border-radius-default small hollow-subscription"
                   style="width: fit-content">
                  <span class="hollow-subscription-text"
                        style="display: flex; align-items: center; font-weight: 500">
                    <i class="fal fa-calendar-check margin-r-xs"
                       style="font-size: 1.2rem"></i>
                    {{'news.event.offer-event' | translate}}
                  </span>
                </a>
              </div>
            </div>
            <!--<span class="hds-chip condensed small margin-b-s margin-r-s get chips {{getColorByTheme(event)}}"
                  style="font-weight:600; text-transform:uppercase; font-size:8px;">
              <ng-container *ngIf="event.theme; else theme">
                {{event.theme}}
              </ng-container>
              <ng-template #theme>
                {{event.category}}
              </ng-template>
            </span>-->

            <!--<div class="cursor-hover"
                 style="float: right">
              &lt;!&ndash;Event links&ndash;&gt;
              <a *ngIf="hasLinkByType(event, linkTypeEnum.SUBSCRIPTION_LINK)"
                 [href]="getLinkByType(event, linkTypeEnum.SUBSCRIPTION_LINK)" (click)="onRedirectToEvent(event, true)"
                 class=" hds-chip condensed light-gray border-radius-default small margin-r-s hollow-subscription">
                <span class="hollow-subscription-text">
                  <i class="fal fa-calendar-star"></i>
                  {{'news.event.subscribe-event' | translate}}
                </span>
              </a>
              <a *ngIf="hasLinkByType(event, linkTypeEnum.COMMERCIAL_LINK) && !hasLinkByType(event, linkTypeEnum.SUBSCRIPTION_LINK)"
                 [href]="getLinkByType(event, linkTypeEnum.COMMERCIAL_LINK)" (click)="onRedirectToEvent(event, false)"
                 class=" hds-chip condensed light-gray border-radius-default small margin-r-s hollow-subscription">
                <span class="hollow-subscription-text">
                  <i class="fal fa-calendar-star"></i>
                  {{'news.event.offer-event' | translate}}
                </span>
              </a>

              &lt;!&ndash;BackOffice actions -> Edit/Delete&ndash;&gt;
              <ng-container *ngIf="isBackOffice">
                <span (click)="openEditEventDialog(event)"
                      class="fa fa-pencil margin-r-s"></span>
                <span (click)="onOpenDeleteContact(event)"
                      class="fa fa-close"></span>
              </ng-container>
            </div>

            <br/>
            <div (click)="gotToProgram(event)"
                 class="cursor-hover padding-t-xs">
              <span class="i-block margin-b-xs f-7 font-bold c-black">{{event.title}}</span><br/>
              <div class="line-clamp">{{event.description}}</div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!--Focus event thumbnails-->
  <!--<ng-container *ngIf="focusEvents.length > 0">
    <div class="cell auto">
      <div *ngFor="let event of focusEvents"
           class="image-event"
           [style.background]="'100% 0 no-repeat url(./assets/img/' + event.category.toLowerCase() +'.png)'">
        <div class="paragraphe-event">
          <div class="d-block text-right">

            <div (click)="gotToProgram(event)"
                 class="icone-image-event bg-{{getColorByTheme(event)}}">
              <i class="fas c-white"
                 style="vertical-align: middle"
                 [ngClass]="{'fa-play': event.category === eventCategoriesEnum.WEBINAR,
                             'fa-star': event.category === eventCategoriesEnum.RENCONTRES,
                             'fa-hands-helping': event.category === eventCategoriesEnum.AUTRES,
                             'fa-users': event.category === eventCategoriesEnum.ACCOMPAGNEMENT,
                             'fa-graduation-cap': event.category === eventCategoriesEnum.CAMPUS
                             }"></i>
            </div>

            &lt;!&ndash;BackOffice actions -> Edit/Delete&ndash;&gt;
            <ng-container *ngIf="isBackOffice">
              <span (click)="openEditEventDialog(event)"
                    class="fa fa-pencil margin-h-s"></span>
              <span (click)="onOpenDeleteContact(event)"
                    class="fa fa-close"></span>
            </ng-container>

          </div>

          <div class="d-block padding-r"
               (click)="gotToProgram(event)">
            <div>
              <h4 style="font-weight:700;">{{event.title}}</h4>
              <div class="c-light-gray line-clamp">
                {{event.description}}
              </div>
            </div>

            <a *ngIf="hasLinkByType(event, linkTypeEnum.SUBSCRIPTION_LINK)"
               [href]="getLinkByType(event, linkTypeEnum.SUBSCRIPTION_LINK)"
               class="button light-gray border-radius-default small margin-t hollow-subscription">
              <span class="hollow-subscription-text">
                <i class="fal fa-calendar-star"></i> {{'news.event.subscribe-event' | translate}}
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </ng-container>-->

</div>
